import { Window } from '../contexts/index.jsx'

const AddressHelper = {
    convertToStripeFormat: (address) => {
        if (!address.city || !address.line1) {
          return null;
        }

        return {
            'name': address.first_name + ' ' + address.last_name,
            'phone': address.phone,
            'address': {
                line1: address.line1,
                line2: address.line2,
                city: address.locality,
                state: address.region,
                postal_code: address.postal_code,
                country: Window.COUNTRIES.find((c) => c.id === address.country_id)?.alpha2Code
            }
        }
    },

    cloneUserAddress: (user) => {
        const address = {...user.address, ...{
            first_name: user.first_name,
            last_name:  user.last_name,
            phone: user.phone
        }}

        if (address.id) {
            delete address.id
        }

        if (address.copied_from_address_id) {
            delete address.copied_from_address_id
        }

        return address
    }
}

export default AddressHelper
